import React, { Component } from "react";
import {
    Logout,
    UserData,
    updatePartnerResidualSplitsDetails,
    getPartnerResidualSplits,
    GetAdminUsers,
} from "../../api";
import "../../../sass/residuals.scss";
import Notifications, { notify } from "react-notify-toast";
import Alert from "../alerts/Alert";
import Header from "../preapps/Header";
import {
    NavDropdown,
    Dropdown,
    NavItem,
    NavLink,
    Col,
    Form,
} from "react-bootstrap";
import { Formik } from "formik";
import Select from "react-select";
import Cleave from "cleave.js/react";
import AlertForSendSignature from "../alerts/AlertForSendSignature";
import { getAlertPopUp } from "../helper/helper";

import * as yup from "yup";
const schema = yup.object({
    residualType: yup.string().trim().required("* This filed is required"),
    volumeTier: yup.string().required("* This filed is required"),
    isPayEMSOr: yup.string().trim().required("* This filed is required"),
    isOverride: yup.string().trim().required("* This filed is required"),
    // For residual type date
    splitDate1: yup
        .number()
        .nullable()
        .when("residualType", (residualType, schema) => {
            return residualType === "Date"
                ? schema
                      .positive()
                      .min(
                          1,
                          "Split date should has to be more than 1 but less than 100",
                      )
                      .max(
                          100,
                          "Split date should has to be more than 1 but less than 100",
                      )
                      .required("* This filed is required")
                : schema;
        }),
    splitDate2: yup
        .number()
        .nullable()
        .when("residualType", (residualType, schema) => {
            return residualType === "Date"
                ? schema
                      .positive()
                      .min(
                          1,
                          "Split date should has to be more than 1 but less than 100",
                      )
                      .max(
                          100,
                          "Split date should has to be more than 1 but less than 100",
                      )
                      .required("* This filed is required")
                : schema;
        }),
    date: yup
        .date()
        .nullable()
        .when("residualType", (residualType, schema) => {
            return residualType === "Date"
                ? schema.required("* This filed is required")
                : schema;
        }),
    // For residual type flat
    flatSplit: yup
        .number()
        .nullable()
        .when("residualType", (residualType, schema) => {
            return residualType === "Flat"
                ? schema
                      .positive()
                      .min(
                          1,
                          "Percentage % has to be more than 1 but less than 100",
                      )
                      .max(
                          100,
                          "Percentage % has to be more than 1 but less than 100",
                      )
                      .required("* This filed is required")
                : schema;
        }),
    // For residual type Processor
    processor1Split: yup
        .number()
        .nullable()
        .when(
            ["residualType", "processor1"],
            (residualType, processor1, schema) => {
                return (residualType === "Processor" ||
                    residualType === "Processor/Risk") &&
                    processor1 != "" &&
                    processor1 != undefined
                    ? schema.positive().required("* This filed is required")
                    : schema;
            },
        ),
    processor2Split: yup
        .number()
        .nullable()
        .when(
            ["residualType", "processor2"],
            (residualType, processor2, schema) => {
                return residualType === "Processor" &&
                    processor2 != "" &&
                    processor2 != undefined
                    ? schema.positive().required("* This filed is required")
                    : schema;
            },
        ),
    processor3Split: yup
        .number()
        .nullable()
        .when(
            ["residualType", "processor3"],
            (residualType, processor3, schema) => {
                return residualType === "Processor" &&
                    processor3 != "" &&
                    processor3 != undefined
                    ? schema.positive().required("* This filed is required")
                    : schema;
            },
        ),
    processorOtherSplit: yup
        .number()
        .nullable()
        .when(["residualType"], (residualType, schema) => {
            return residualType === "Processor"
                ? schema.positive().required("* This filed is required")
                : schema;
        }),
    // For residual type Processor/Risk
    highRisk: yup
        .number()
        .nullable()
        .when(["residualType"], (residualType, schema) => {
            return residualType === "Processor/Risk" || residualType === "Risk"
                ? schema.positive().required("* This filed is required")
                : schema;
        }),
    lowRisk: yup
        .number()
        .nullable()
        .when(["residualType"], (residualType, schema) => {
            return residualType === "Processor/Risk" || residualType === "Risk"
                ? schema.positive().required("* This filed is required")
                : schema;
        }),
});
class PartnerEditPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {},
            zohoAdminUserList: {},
            showAlert: false,
            alertHeader: "",
            alertMessage: "",
            variant: "success",
            formData: {
                highRisk: "",
                lowRisk: "",
                processor1: "",
                processor1Split: "",
                processor2: "",
                processor2Split: "",
                processor3: "",
                processor3Split: "",
                processorOtherSplit: "",
                residualType: "",
                volumeTier: "0",
                volumeTier1: "",
                volumeTier1Split: "",
                volumeTier2: "",
                volumeTier2Split: "",
                volumeTier3: "",
                volumeTier3Split: "",
                flatSplit: "",
                splitDate1: "",
                date: "",
                splitDate2: "",
                isPayEMSOr: 0,
                isOverride: false,
                overrideUserId: "",
                overridePercentage: 0,
            },
            processorType: ["EMS", "EMS OR", "Priority CBD"],
            is_submitted: false,
            show_spinner: false,
            errorMessage: "",
            errors: [],
        };
        localStorage.setItem("pageSize", 10);
    }
    componentDidMount() {
        const organization_id = this.props.organizationId;
        getPartnerResidualSplits(organization_id).then((response) => {
            let data = response.data;
            if (data) {
                let formData = this.state.formData;
                formData["date"] = data.date;
                formData["residualType"] = data.residual_type ?? "";
                formData["flatSplit"] = data.flat_split ?? "";
                formData["splitDate1"] = data.split_date_1 ?? "";
                formData["splitDate2"] = data.split_date_2 ?? "";
                formData["volumeTier"] = data.volume_tiers ?? "";
                formData["processor1"] = data.processor_1 ?? "";
                formData["processor1Split"] = data.processor_1_split ?? "";
                formData["processor2"] = data.processor_2 ?? "";
                formData["processor2Split"] = data.processor_2_split ?? "";
                formData["processor3"] = data.processor_3 ?? "";
                formData["processor3Split"] = data.processor_3_split ?? "";
                formData["processorOtherSplit"] =
                    data.processor_other_split ?? "";
                formData["highRisk"] = data.risk_hr_split ?? "";
                formData["lowRisk"] = data.risk_lr_split ?? "";
                formData["isPayEMSOr"] = data.is_pay_ems_or == 0 ? false : true;
                formData["volumeTier1"] = data.vol_tier_1 ?? "";
                formData["volumeTier1Split"] = data.vol_tier_1_split ?? "";
                formData["volumeTier2"] = data.vol_tier_2 ?? "";
                formData["volumeTier2Split"] = data.vol_tier_2_split ?? "";
                formData["volumeTier3"] = data.vol_tier_3 ?? "";
                formData["volumeTier3Split"] = data.vol_tier_3_split ?? "";
                formData["isOverride"] =
                    data.override_split == 0 ? false : true;
                formData["overrideUserId"] = data.override_user_id;
                this.setState({ formData: formData });
            }
        });
        UserData().then((response) => {
            this.setState({
                user: response,
            });
        });
        GetAdminUsers().then((response) => {
            if (response.success) {
                let UsersOptionsList = [];
                response.users.map((data, i) => {
                    UsersOptionsList.push({
                        label: data.name,
                        value: data.id,
                    });
                });
                this.setState({
                    zohoAdminUserList: UsersOptionsList,
                });
            }
        });
    }

    logout() {
        Logout()
            .then((response) => {
                window.location = "/";
            })
            .catch((error) => console.log(error));
    }
    handleChangeResidualTierType = (e) => {
        this.setState({
            volumeTier: e.target.value,
        });
    };
    handleChangeResidualType = (e) => {
        let formData = this.state.formData;
        formData["residualType"] = e.target.value.trim();
        this.setState({ formData: formData, errorMessage: "" });
    };
    handleProcessorChange = (e, fieldName) => {
        this.setState({
            [fieldName]: e.target.value,
        });
    };
    handleUserOverrideChange = (event) => {
        this.setState({
            overrideUserId: event,
        });
    };

    onPartnerEditSave = () => {
        let data = {
            highRisk: this.state.formData.highRisk,
            lowRisk: this.state.formData.lowRisk,
            processor1: this.state.formData.processor1,
            processor1Split: this.state.formData.processor1Split,
            processor2: this.state.formData.processor2,
            processor2Split: this.state.formData.processor2Split,
            processor3: this.state.formData.processor3,
            processor3Split: this.state.formData.processor3Split,
            processorOtherSplit: this.state.formData.processorOtherSplit,
            residualType: this.state.formData.residualType,
            volumeTier: this.state.formData.volumeTier,
            volumeTier1: this.state.formData.volumeTier1,
            volumeTier1Split: this.state.formData.volumeTier1Split,
            volumeTier2: this.state.formData.volumeTier2,
            volumeTier2Split: this.state.formData.volumeTier2Split,
            volumeTier3: this.state.formData.volumeTier3,
            volumeTier3Split: this.state.formData.volumeTier3Split,
            flatSplit: this.state.formData.flatSplit,
            splitDate1: this.state.formData.splitDate1,
            date: this.state.formData.date,
            splitDate2: this.state.formData.splitDate2,
            isPayEMSOr:
                this.state.formData.isPayEMSOr == "true" ||
                this.state.formData.isPayEMSOr == true
                    ? 1
                    : 0,
            isOverride:
                this.state.formData.isOverride == "true" ||
                this.state.formData.isOverride == true
                    ? 1
                    : 0,
            overrideUserId: this.state.formData.overrideUserId,
            overridePercentage: this.state.formData.overridePercentage,
        };
        const organization_id = this.props.organizationId;
        updatePartnerResidualSplitsDetails(organization_id, data)
            .then((response) => {
                const popup = {
                    title: "Success!",
                    html: "Record has been saved successfully",
                };
                getAlertPopUp(popup);
            })
            .catch((error) => {});
    };

    handleOverrideUsersDefaults = () => {
        let UsersDefaults = [];

        this.state.zohoAdminUserList.forEach((item2) => {
            if (item2.value == this.state.overrideUserId) {
                UsersDefaults.push(item2);
            }
        });
        return UsersDefaults;
    };

    updateChange(evt) {
        const targetName = evt.target.name;
        if (targetName === "") {
            return false;
        }
        let formData = this.state.formData;
        formData[targetName] = evt.target.value.trim();
        this.setState({ formData: formData, errorMessage: "" });
    }

    render() {
        const {
            showAlert,
            alertHeader,
            alertMessage,
            variant,
            user,
            processorType,
            zohoAdminUserList,
            isOverride,
            overridePercentage,
            is_submitted,
            show_spinner,
            errorMessage,
            formData,
            errors,
        } = this.state;
        return (
            <div className="website-wrapper application-page residual-page">
                <Header
                    header_user_name={user.name}
                    user={user}
                    onLogout={this.logout}
                />
                <div className="">
                    <div id="page-content-wrapper">
                        <Notifications />
                        {showAlert && (
                            <AlertForSendSignature
                                showAlert={showAlert}
                                heading=""
                                message={alertMessage}
                                variant={variant}
                                handleDismissible={() => {
                                    this.setState({ showAlert: false });
                                }}
                            />
                        )}
                        <div>
                            <div className="panel-body">
                                <Formik
                                    enableReinitialize
                                    validationSchema={schema}
                                    onSubmit={(e) => this.onPartnerEditSave(e)}
                                    initialValues={formData}
                                    initialErrors={errors}
                                    validateOnBlur={false}
                                    validateOnChange={is_submitted}
                                    validate={(values) => {
                                        this.setState({ is_submitted: true });
                                    }}
                                >
                                    {({
                                        handleSubmit,
                                        handleChange,
                                        values,
                                        touched,
                                        errors,
                                    }) => (
                                        <Form
                                            id="splits-form"
                                            onSubmit={handleSubmit}
                                            onChange={(e) =>
                                                this.updateChange(e)
                                            }
                                            autoComplete="off"
                                        >
                                            <div className="row">
                                                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                                                    <select
                                                        className="form-control"
                                                        value={
                                                            values.residualType
                                                        }
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        name="residualType"
                                                    >
                                                        <option
                                                            value=""
                                                            disabled
                                                        >
                                                            Select One
                                                        </option>
                                                        <option value="Date">
                                                            Date
                                                        </option>
                                                        <option value="Flat">
                                                            Flat
                                                        </option>
                                                        <option value="Processor">
                                                            Processor
                                                        </option>
                                                        <option value="Processor/Risk">
                                                            Processor/Risk
                                                        </option>
                                                        <option value="Risk">
                                                            Risk
                                                        </option>
                                                    </select>
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {" "}
                                                        {
                                                            errors.residualType
                                                        }{" "}
                                                    </Form.Control.Feedback>
                                                </div>
                                                {values.residualType && (
                                                    <div className="row">
                                                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1">
                                                            <button
                                                                form="splits-form"
                                                                className="btn btn-primary"
                                                                type="submit"
                                                            >
                                                                Save
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            {values.residualType == "Flat" && (
                                                <div>
                                                    <>
                                                        <div className="row">
                                                            &nbsp;
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                                                                <Cleave
                                                                    options={{
                                                                        blocks: [
                                                                            3,
                                                                        ],
                                                                        numeral: true,
                                                                    }}
                                                                    placeholder="Percentage"
                                                                    name="flatSplit"
                                                                    value={
                                                                        values.flatSplit
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) => {
                                                                        handleChange(
                                                                            e,
                                                                        );
                                                                    }}
                                                                    type="text"
                                                                    className="form-control"
                                                                />
                                                                <Form.Control.Feedback
                                                                    type="invalid"
                                                                    className="text-capitalize"
                                                                >
                                                                    {" "}
                                                                    {
                                                                        errors.flatSplit
                                                                    }{" "}
                                                                </Form.Control.Feedback>
                                                            </div>
                                                        </div>
                                                    </>
                                                </div>
                                            )}
                                            {values.residualType == "Date" && (
                                                <>
                                                    <div className="row">
                                                        &nbsp;
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 text-center">
                                                            <Cleave
                                                                options={{
                                                                    blocks: [3],
                                                                    numericOnly: true,
                                                                }}
                                                                placeholder="Split Date 1"
                                                                name="splitDate1"
                                                                value={
                                                                    values.splitDate1
                                                                }
                                                                onChange={(
                                                                    e,
                                                                ) => {
                                                                    handleChange(
                                                                        e,
                                                                    );
                                                                }}
                                                                type="text"
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                                className="form-control"
                                                            />
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {" "}
                                                                {
                                                                    errors.splitDate1
                                                                }{" "}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        &nbsp;
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 text-center">
                                                            <input
                                                                className="form-control"
                                                                type="date"
                                                                name="date"
                                                                onChange={(
                                                                    e,
                                                                ) => {
                                                                    handleChange(
                                                                        e,
                                                                    );
                                                                }}
                                                                value={
                                                                    values.date
                                                                }
                                                                placeholder="Date"
                                                            />
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {" "}
                                                                {
                                                                    errors.date
                                                                }{" "}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        &nbsp;
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 text-center">
                                                            <Cleave
                                                                options={{
                                                                    blocks: [3],
                                                                    numericOnly: true,
                                                                }}
                                                                placeholder="Split Date 2"
                                                                name="splitDate2"
                                                                value={
                                                                    values.splitDate2
                                                                }
                                                                onChange={(
                                                                    e,
                                                                ) => {
                                                                    handleChange(
                                                                        e,
                                                                    );
                                                                }}
                                                                type="text"
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                                className="form-control"
                                                            />
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {" "}
                                                                {
                                                                    errors.splitDate2
                                                                }{" "}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                            {(values.residualType ==
                                                "Processor" ||
                                                values.residualType ==
                                                    "Processor/Risk") && (
                                                <div>
                                                    <div className="row">
                                                        &nbsp;
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                            <select
                                                                className="form-control"
                                                                value={
                                                                    values.processor1
                                                                }
                                                                onChange={(
                                                                    e,
                                                                ) => {
                                                                    handleChange(
                                                                        e,
                                                                    );
                                                                }}
                                                                name="processor1"
                                                            >
                                                                <option value="">
                                                                    Select One
                                                                </option>
                                                                {processorType.map(
                                                                    (item) => {
                                                                        return (
                                                                            <option
                                                                                key={
                                                                                    item
                                                                                }
                                                                                value={
                                                                                    item
                                                                                }
                                                                            >
                                                                                {
                                                                                    item
                                                                                }
                                                                            </option>
                                                                        );
                                                                    },
                                                                )}
                                                            </select>
                                                        </div>
                                                        <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-center">
                                                            <Cleave
                                                                options={{
                                                                    numeral: true,
                                                                }}
                                                                placeholder="Processor 1"
                                                                name="processor1Split"
                                                                value={
                                                                    values.processor1Split
                                                                }
                                                                onChange={(
                                                                    e,
                                                                ) => {
                                                                    handleChange(
                                                                        e,
                                                                    );
                                                                }}
                                                                type="text"
                                                                className="form-control"
                                                            />
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {" "}
                                                                {
                                                                    errors.processor1Split
                                                                }{" "}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                    </div>
                                                    {values.residualType ==
                                                        "Processor" && (
                                                        <div>
                                                            <div className="row">
                                                                &nbsp;
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-center">
                                                                    <select
                                                                        className="form-control"
                                                                        value={
                                                                            values.processor2
                                                                        }
                                                                        onChange={(
                                                                            e,
                                                                        ) => {
                                                                            handleChange(
                                                                                e,
                                                                            );
                                                                        }}
                                                                        name="processor2"
                                                                    >
                                                                        <option value="">
                                                                            Select
                                                                            One
                                                                        </option>
                                                                        {processorType.map(
                                                                            (
                                                                                item,
                                                                            ) => {
                                                                                return (
                                                                                    <option
                                                                                        key={
                                                                                            item
                                                                                        }
                                                                                        value={
                                                                                            item
                                                                                        }
                                                                                    >
                                                                                        {
                                                                                            item
                                                                                        }
                                                                                    </option>
                                                                                );
                                                                            },
                                                                        )}
                                                                    </select>
                                                                </div>
                                                                <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-center">
                                                                    <Cleave
                                                                        options={{
                                                                            numeral: true,
                                                                        }}
                                                                        placeholder="Processor 2"
                                                                        name="processor2Split"
                                                                        value={
                                                                            values.processor2Split
                                                                        }
                                                                        onChange={(
                                                                            e,
                                                                        ) => {
                                                                            handleChange(
                                                                                e,
                                                                            );
                                                                        }}
                                                                        type="text"
                                                                        className="form-control"
                                                                    />
                                                                    <Form.Control.Feedback
                                                                        type="invalid"
                                                                        className="text-capitalize"
                                                                    >
                                                                        {" "}
                                                                        {
                                                                            errors.processor2Split
                                                                        }{" "}
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                &nbsp;
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-center">
                                                                    <select
                                                                        className="form-control"
                                                                        value={
                                                                            values.processor3
                                                                        }
                                                                        onChange={(
                                                                            e,
                                                                        ) => {
                                                                            handleChange(
                                                                                e,
                                                                            );
                                                                        }}
                                                                        name="processor3"
                                                                    >
                                                                        <option value="">
                                                                            Select
                                                                            One
                                                                        </option>
                                                                        {processorType.map(
                                                                            (
                                                                                item,
                                                                            ) => {
                                                                                return (
                                                                                    <option
                                                                                        key={
                                                                                            item
                                                                                        }
                                                                                        value={
                                                                                            item
                                                                                        }
                                                                                    >
                                                                                        {
                                                                                            item
                                                                                        }
                                                                                    </option>
                                                                                );
                                                                            },
                                                                        )}
                                                                    </select>
                                                                </div>
                                                                <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-center">
                                                                    <Cleave
                                                                        options={{
                                                                            numeral: true,
                                                                        }}
                                                                        placeholder="Processor 3"
                                                                        name="processor3Split"
                                                                        value={
                                                                            values.processor3Split
                                                                        }
                                                                        onChange={(
                                                                            e,
                                                                        ) => {
                                                                            handleChange(
                                                                                e,
                                                                            );
                                                                        }}
                                                                        type="text"
                                                                        className="form-control"
                                                                    />
                                                                    <Form.Control.Feedback
                                                                        type="invalid"
                                                                        className="text-capitalize"
                                                                    >
                                                                        {" "}
                                                                        {
                                                                            errors.processor3Split
                                                                        }{" "}
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                &nbsp;
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                                                                    <Cleave
                                                                        options={{
                                                                            numeral: true,
                                                                        }}
                                                                        placeholder="Processor Other Split"
                                                                        name="processorOtherSplit"
                                                                        value={
                                                                            values.processorOtherSplit
                                                                        }
                                                                        onChange={(
                                                                            e,
                                                                        ) => {
                                                                            handleChange(
                                                                                e,
                                                                            );
                                                                        }}
                                                                        type="text"
                                                                        className="form-control"
                                                                    />
                                                                    <Form.Control.Feedback
                                                                        type="invalid"
                                                                        className="text-capitalize"
                                                                    >
                                                                        {" "}
                                                                        {
                                                                            errors.processorOtherSplit
                                                                        }{" "}
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                            {(values.residualType == "Risk" ||
                                                values.residualType ==
                                                    "Processor/Risk") && (
                                                <div>
                                                    <div className="row">
                                                        &nbsp;
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                            <Cleave
                                                                options={{
                                                                    numeral: true,
                                                                }}
                                                                placeholder="High Risk"
                                                                name="highRisk"
                                                                value={
                                                                    values.highRisk
                                                                }
                                                                onChange={(
                                                                    e,
                                                                ) => {
                                                                    handleChange(
                                                                        e,
                                                                    );
                                                                }}
                                                                type="text"
                                                                className="form-control"
                                                            />
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {" "}
                                                                {
                                                                    errors.highRisk
                                                                }{" "}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                        <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                            <Cleave
                                                                options={{
                                                                    numeral: true,
                                                                }}
                                                                placeholder="Low Risk"
                                                                name="lowRisk"
                                                                value={
                                                                    values.lowRisk
                                                                }
                                                                onChange={(
                                                                    e,
                                                                ) => {
                                                                    handleChange(
                                                                        e,
                                                                    );
                                                                }}
                                                                type="text"
                                                                className="form-control"
                                                            />
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {" "}
                                                                {
                                                                    errors.lowRisk
                                                                }{" "}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            <div>
                                                <div className="row">
                                                    <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                                                        <div className="row">
                                                            &nbsp;
                                                        </div>
                                                        <div>
                                                            <div>
                                                                Volume Tier
                                                            </div>
                                                            <input
                                                                type="radio"
                                                                name="volumeTier"
                                                                checked={
                                                                    values.volumeTier ==
                                                                    "1"
                                                                }
                                                                value="1"
                                                                onChange={(
                                                                    e,
                                                                ) => {
                                                                    handleChange(
                                                                        e,
                                                                    );
                                                                }}
                                                            />{" "}
                                                            Yes
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            <input
                                                                type="radio"
                                                                name="volumeTier"
                                                                value="0"
                                                                checked={
                                                                    values.volumeTier ==
                                                                    "0"
                                                                }
                                                                onChange={(
                                                                    e,
                                                                ) => {
                                                                    handleChange(
                                                                        e,
                                                                    );
                                                                }}
                                                            />{" "}
                                                            No
                                                        </div>
                                                        <Form.Control.Feedback
                                                            type="invalid"
                                                            className="text-capitalize"
                                                        >
                                                            {" "}
                                                            {
                                                                errors.volumeTier
                                                            }{" "}
                                                        </Form.Control.Feedback>
                                                    </div>
                                                </div>
                                                {values.volumeTier == "1" && (
                                                    <div>
                                                        <div className="row">
                                                            &nbsp;
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                                <label>
                                                                    V.1 Tier
                                                                </label>
                                                                <Cleave
                                                                    options={{
                                                                        numericOnly: true,
                                                                    }}
                                                                    name="volumeTier1"
                                                                    value={
                                                                        values.volumeTier1
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) => {
                                                                        handleChange(
                                                                            e,
                                                                        );
                                                                    }}
                                                                    type="text"
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                            <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                                <label>
                                                                    V.1 Tier
                                                                    Split
                                                                </label>
                                                                <Cleave
                                                                    options={{
                                                                        numericOnly: true,
                                                                    }}
                                                                    name="volumeTier1Split"
                                                                    value={
                                                                        values.volumeTier1Split
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) => {
                                                                        handleChange(
                                                                            e,
                                                                        );
                                                                    }}
                                                                    type="text"
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            &nbsp;
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                                <label>
                                                                    V.2 Tier
                                                                </label>
                                                                <Cleave
                                                                    options={{
                                                                        numericOnly: true,
                                                                    }}
                                                                    name="volumeTier2"
                                                                    value={
                                                                        values.volumeTier2
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) => {
                                                                        handleChange(
                                                                            e,
                                                                        );
                                                                    }}
                                                                    type="text"
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                            <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                                <label>
                                                                    V.2 Tier
                                                                    Split
                                                                </label>
                                                                <Cleave
                                                                    options={{
                                                                        numericOnly: true,
                                                                    }}
                                                                    name="volumeTier2Split"
                                                                    value={
                                                                        values.volumeTier2Split
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) => {
                                                                        handleChange(
                                                                            e,
                                                                        );
                                                                    }}
                                                                    type="text"
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            &nbsp;
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                                <label>
                                                                    V.3 Tier
                                                                </label>
                                                                <Cleave
                                                                    options={{
                                                                        numericOnly: true,
                                                                    }}
                                                                    name="volumeTier3"
                                                                    value={
                                                                        values.volumeTier3
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) => {
                                                                        handleChange(
                                                                            e,
                                                                        );
                                                                    }}
                                                                    type="text"
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                            <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                                <label>
                                                                    V.3 Tier
                                                                    Split
                                                                </label>
                                                                <Cleave
                                                                    options={{
                                                                        numericOnly: true,
                                                                    }}
                                                                    name="volumeTier3Split"
                                                                    value={
                                                                        values.volumeTier3Split
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) => {
                                                                        handleChange(
                                                                            e,
                                                                        );
                                                                    }}
                                                                    type="text"
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="row">&nbsp;</div>
                                            <div>
                                                <div className="row">
                                                    <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                        <input
                                                            type="checkbox"
                                                            id="isPayEMSOr"
                                                            className="form-check-input"
                                                            name="isPayEMSOr"
                                                            checked={
                                                                values.isPayEMSOr ==
                                                                true
                                                            }
                                                            value={
                                                                !values.isPayEMSOr
                                                            }
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                        />
                                                        &nbsp;&nbsp;
                                                        <label
                                                            htmlFor="web-checkout"
                                                            className="form-check-label"
                                                        >
                                                            <span className="preapp-checkbox" />
                                                            Is Pay EMS OR
                                                        </label>
                                                    </div>
                                                    <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                        <input
                                                            type="checkbox"
                                                            id="isOverride"
                                                            className="form-check-input"
                                                            name="isOverride"
                                                            checked={
                                                                values.isOverride ==
                                                                true
                                                            }
                                                            value={
                                                                !values.isOverride
                                                            }
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                        />
                                                        &nbsp;
                                                        <label
                                                            htmlFor="web-checkout"
                                                            className="form-check-label"
                                                        >
                                                            <span className="preapp-checkbox" />
                                                            Is Override
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                                <div className="row">&nbsp;</div>
                                <div>
                                    <div className="row">
                                        <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                            {Object.keys(zohoAdminUserList)
                                                .length && isOverride ? (
                                                <Select
                                                    name="overrideUserId"
                                                    placeholder="Select Override User"
                                                    defaultValue={this.handleOverrideUsersDefaults()}
                                                    onChange={(selected) => {
                                                        this.handleUserOverrideChange(
                                                            selected.value,
                                                        );
                                                    }}
                                                    isMulti={false}
                                                    options={zohoAdminUserList}
                                                />
                                            ) : null}
                                        </div>
                                        <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                            {isOverride ? (
                                                <div>
                                                    <input
                                                        className="form-control"
                                                        type="textbox"
                                                        name="overridePercentage"
                                                        onChange={(e) =>
                                                            this.setState({
                                                                overridePercentage:
                                                                    e.target
                                                                        .value,
                                                            })
                                                        }
                                                        value={
                                                            overridePercentage
                                                        }
                                                    />
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">&nbsp;</div>
                                <div className="row">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default PartnerEditPage;
